import React from "react";
import { Box, Typography } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import shirt1 from "../../assets/images/shirt1.png";
import shirt2 from "../../assets/images/shirt2.png";
import shirt3 from "../../assets/images/shirt3.png";
import shirt4 from "../../assets/images/shirt4.png";
export default function Designs() {
  const testimonials = [
    {
      image: shirt1,
    },
    {
      image: shirt2,
    },
    {
      image: shirt3,
    },
    {
      image: shirt4,
    },
    {
      image: shirt3,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };
  return (
    <Box className="designs-section" id="recent-designs">
      <Typography variant="h3" className="design-heading">
        Recent Designs
      </Typography>
      <Typography className="design-content">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt
      </Typography>
      <Box>
        <Box
          justifyContent={"center"}
          sx={{ paddingBottom: "52px", marginX: { md: "113px", xs: "10px" } }}
        >
          <Box className={"testimonials"}>
            <Box>
              <Box className={` slider `}>
                <Slider {...settings}>
                  {testimonials.map((data) => (
                    <Box
                      overflow={"hidden"}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={data.image}
                        style={{
                          width: "200px",
                          height: "300px",
                          margin: "0 auto",
                          padding: "auto",
                          objectPosition: "center center",
                        }}
                        alt="pic"
                      />
                    </Box>
                  ))}
                </Slider>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
